module.exports = __webpack_public_path__ + "static/media/heatmap.fragment.3cbcd9c3.glsl";